import React, { useState, useEffect } from 'react';
import { Menu, X, Coffee, ChevronRight } from 'lucide-react';

const NAV_LINKS = [
  { name: 'Features', href: '#how-it-works' },
  { name: 'Our Work', href: '#stories' },
  { name: 'Concept Lab', href: '#guide' },
  { name: 'Pricing', href: '#build-system' },
];

const Navbar: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled || isOpen ? 'py-4 glass shadow-sm' : 'py-6 bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex justify-between items-center">
          <a href="#" className="flex items-center gap-3 group">
            <div className="bg-[#7FAF9A] p-2 rounded-xl text-white shadow-sm group-hover:scale-110 transition-transform">
              <Coffee size={20} />
            </div>
            <span className={`text-base sm:text-lg font-extrabold tracking-tight transition-colors ${
              scrolled || isOpen ? 'text-[#1F2933]' : 'text-white'
            }`}>
              Tiny Systems
            </span>
          </a>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center space-x-10">
            {NAV_LINKS.map((link) => (
              <a 
                key={link.name}
                href={link.href} 
                className={`text-xs font-black uppercase tracking-[0.2em] transition-all hover:opacity-100 ${
                  scrolled ? 'text-[#1F2933]/60 hover:text-[#7FAF9A]' : 'text-white/60 hover:text-white'
                }`}
              >
                {link.name}
              </a>
            ))}
            <a 
              href="#build-system" 
              className={`px-5 py-2.5 rounded-xl font-black text-xs uppercase tracking-widest transition-all ${
                scrolled 
                  ? 'bg-[#7FAF9A] text-white hover:bg-[#6b9a87]' 
                  : 'bg-white/10 text-white hover:bg-white/20 backdrop-blur-md'
              }`}
            >
              Get Started
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button 
              onClick={() => setIsOpen(!isOpen)} 
              className={`p-2 rounded-xl transition-colors ${
                scrolled || isOpen ? 'bg-[#1F2933]/5 text-[#1F2933]' : 'bg-white/10 text-white'
              }`}
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-[#1F2933]/5 p-6 animate-in slide-in-from-top-2 duration-300 shadow-2xl">
          <div className="flex flex-col space-y-1">
            {NAV_LINKS.map((link) => (
              <a 
                key={link.name}
                href={link.href} 
                onClick={() => setIsOpen(false)} 
                className="flex items-center justify-between p-4 rounded-2xl hover:bg-[#F4F1EC] transition-colors group"
              >
                <span className="text-lg font-extrabold text-[#1F2933]">{link.name}</span>
                <ChevronRight size={18} className="text-[#1F2933]/20 group-hover:text-[#7FAF9A] transition-colors" />
              </a>
            ))}
            <div className="pt-4 px-2">
              <a 
                href="#build-system" 
                onClick={() => setIsOpen(false)}
                className="w-full bg-[#7FAF9A] text-white py-4 rounded-2xl font-black text-center block shadow-lg shadow-green-900/10"
              >
                CUSTOMIZE YOUR SYSTEM
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
